import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './src/contexts/AppContext'

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, sans-serif',
    h1: { fontWeight: 600 },
    body1: { fontWeight: 400 },
    button: { fontWeight: 500, textTransform: 'none' },
  },
});

export const wrapRootElement = ({ element }) => (
  <AuthProvider>
  <ThemeProvider theme={theme}>
    <CssBaseline />
    {element}
  </ThemeProvider>
  </AuthProvider>
);